import { render, staticRenderFns } from "./RadioButtonExtension.vue?vue&type=template&id=e3cfc8e2&scoped=true&"
import script from "./RadioButtonExtension.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonExtension.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtonExtension.vue?vue&type=style&index=0&id=e3cfc8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cfc8e2",
  null
  
)

export default component.exports